import { useMemo, useState } from "react";
import { Box, HStack, VStack } from "../../components/utils";
import BCHeader from "../../shared/BCHeader";
import { CompanyProfile } from "./CompanyProfile";
import BlackOutDates from "./BlackOutDates";
import SecurityClass from "./SecurityClass";
import DesignatedPersons from "./DesignatedPersons";
import PaymentDetails from "./PaymentDetails";

function CompanyProfileStepper() {
  const steps = useMemo(
    () => [
      { label: "Company Details", component: <CompanyProfile /> },
      { label: "Designated Persons", component: <DesignatedPersons /> },
      { label: "Blackout Dates", component: <BlackOutDates /> },
      { label: "Security Classes", component: <SecurityClass /> },
      { label: "Payment Details", component: <PaymentDetails /> },
    ],
    []
  );
  const [activeStep, setActiveStep] = useState<string>(steps[0].label);

  return (
    <VStack className="gap-4">
      <div className="flex items-baseline justify-between">
        <BCHeader
          className="items-baseline "
          bcTitle="Settings"
          bcSubTitle="Company Settings"
        />
      </div>
      <Box className="my-auto rounded-lg drop-shadow-md">
        <HStack className="w-full gap-4">
          <Box className="h-full min-h-full bg-white rounded-lg w-21 min-w-min">
            <Box className="items-center p-4 mt-10 text-lg font-medium text-gray-dark whitespace-nowrap">
              Company Settings Menu
            </Box>
            <VStack className=" h-[500px]">
              {steps.map((step) => (
                <Box
                  key={step.label}
                  className={`cursor-pointer form-label text-sm font-medium p-4 whitespace-nowrap ${
                    activeStep === step.label ? "rounded text-orange-501" : ""
                  }`}
                  onClick={() => setActiveStep(step.label)}
                >
                  {step.label}
                </Box>
              ))}
            </VStack>
          </Box>
          <Box className="flex w-full bg-white grow">
            <Box className="flex-1 w-full">
              {steps.find((step) => step.label === activeStep)?.component}
            </Box>
          </Box>
        </HStack>
      </Box>
    </VStack>
  );
}

export default CompanyProfileStepper;
